import {Dialog, DialogContent, DialogTitle} from '@mui/material';

export interface HelpButtonDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  videoUrl?: string;
}

export function HelpButtonDialog({open, onClose, description, title, videoUrl}: HelpButtonDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p>{description}</p>
        {videoUrl && (
          <iframe
            width="100%"
            height="315"
            src={`https://www.youtube.com/embed/${videoUrl.split('/').pop()}`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{marginTop: '1rem'}}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
